import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=2f836f65&scoped=true&"
import script from "./PeriodFilter.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeriodFilter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f836f65",
  null
  
)

export default component.exports